export type ClassValue = string | number | false | null | undefined;

/**
 * Join non-falsy class fragments into a single string. Accepts strings,
 * numbers (rare but harmless: filtered if 0), and the usual falsy slots
 * that show up in `cond && 'name'` patterns.
 */
export function classes(...parts: Array<ClassValue>): string {
  return parts.filter((p): p is string | number => Boolean(p)).join(' ');
}
